import React from 'react';

import InformationIcon from '@atlaskit/icon/core/information';
import type { GlyphProps } from '@atlaskit/icon/types';
import { token } from '@atlaskit/tokens';

export const InfoIcon = ({ label }: GlyphProps) => (
	<InformationIcon testId="info-icon" label={label} color={token('color.icon.subtle')} />
);
